"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationContent = void 0;
exports.NotificationContent = {
  en: {
    title: "Added to Cart",
    alt: "ALT: ",
    leadTime: "Lead Time: ",
    extendedPrice: "Extended Price",
    qty: "Qty: ",
    products: "product(s)",
    addTitle: "Added to Cart",
    removeTitle: "Removed from Cart",
    product: "product",
    undo: "Undo",
    priceShownInCart: "Price shown in cart",
    priceInCart: "In cart",
    days: "day(s)",
    tbd: "TBD"
  },
  es: {
    title: "Añadido al carrito",
    alt: "ALT: ",
    leadTime: "Tiempo de espera: ",
    extendedPrice: "Precio ampliado",
    qty: "Cantidad: ",
    products: "producto(s)",
    addTitle: "Added to Cart",
    removeTitle: "Removed from Cart",
    product: "product",
    undo: "Undo",
    priceShownInCart: "Precio mostrado en el carrito",
    priceInCart: "En el carrito",
    days: "día(s)",
    tbd: "à déterminer"
  },
  fr: {
    title: "Ajouté au panier",
    alt: "ALT: ",
    leadTime: "Délai de mise en œuvre: ",
    extendedPrice: "Prix prolongée",
    qty: "Quantité: ",
    products: "produit(s)",
    addTitle: "Added to Cart",
    removeTitle: "Removed from Cart",
    product: "product",
    undo: "Undo",
    priceShownInCart: "Le prix est affiché dans le panier",
    priceInCart: "Dans le panier",
    days: "journée(s)",
    tbd: "por determinar"
  }
};